import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyAm7ogJyOqB0MtE9nMQqLzGLOjbNkp9jrg',
  authDomain: 'wirth-hats-45d30.firebaseapp.com',
  projectId: 'wirth-hats-45d30',
  storageBucket: 'wirth-hats-45d30.appspot.com',
  messagingSenderId: '58143364763',
  appId: '1:58143364763:web:227dceb1af13d1d2ee983e',
  measurementId: 'G-6M5S6P3TNM'
};

initializeApp(firebaseConfig);
